import type { Distribution } from "@memorang/types";

const getRandomNumber = (max: number) => Math.floor(Math.random() * max) + 1;

export const randomizeDistribution = (distribution: Distribution) => {
	for (const key in distribution) {
		distribution[key as keyof Distribution] = getRandomNumber(15);
	}
	return distribution;
};
